import { Component, Input } from '@angular/core';
import { SharedModule } from '@/app/shared/shared.module';

export interface DeviceCountInfo {
  deviceLineCode: string;
  name: string;
  iconURL: string;
  count: number;
}

@Component({
  selector: 'dk-device-count-indicator',
  imports: [SharedModule],
  templateUrl: './device-count-indicator.component.html',
  styleUrl: './device-count-indicator.component.less',
})
export class DeviceCountIndicatorComponent {
  @Input() devices: DeviceCountInfo[] = [];
}
